// extracted by mini-css-extract-plugin
module.exports = {"root":"blog_root__2MaXg"};